module.exports = __webpack_public_path__ + "static/media/Roast_Toma_Root.87489951.webp";